var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadSyringeWithHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.94453 459.2",
    enableBackground: "new 0 0 1190.6 841.9",
    width: 406.94452,
    height: 459.20001,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2973"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000115474092454873401840000018190816318415544732_",
    transform: "translate(-481.5,-161.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,1.91373,0,-35.0109)",
    display: "none",
    id: "g2762"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9855,-0.1695,0.1695,0.9855,-28.3446,117.6927)",
    display: "inline",
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 675,
    cy: 224.8,
    rx: 4.4000001,
    ry: 6,
    id: "ellipse2758"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9855,-0.1695,0.1695,0.9855,-28.3446,117.6927)",
    display: "inline",
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 675,
    cy: 224.8,
    rx: 4.4000001,
    ry: 6,
    id: "ellipse2760"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(-481.5,-161.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2891"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 638.40002,
    cy: 609.70001,
    rx: 137,
    ry: 8.1999998,
    id: "ellipse2765"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    points: "525.3,605.7 642.6,609.2 674.4,590.9 671.4,528.7 494.1,525.4 495.8,585.3 ",
    id: "polygon2767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 494.1,525.4 1.7,59.8 29.4,20.5 117.3,3.5 31.8,-18.3 -3,-62.2 z m 20.4,20.1 138.1,2.5 1.4,31.7 -16.5,9.5 c -19.8,-0.6 -85.7,-2.6 -105.9,-3.2 l -16.5,-11.5 z",
    id: "path2769"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 663.9,503.9 h 23 v 60.6 c 0,11.9 -4.7,23.2 -13.1,31.7 -4.6,4.6 -10,8.1 -15.9,10.2 1.6,0.9 2.3,1.9 2.3,2.8 0,6.4 -34,11.6 -76,11.6 -42,0 -76,-5.2 -76,-11.6 0,-1 0.8,-1.9 2.3,-2.8 -5.9,-2.2 -11.3,-5.7 -15.9,-10.2 -8.4,-8.4 -13.1,-19.8 -13.1,-31.7 v -60.6 h 25.1 V 548 h 157.3 z",
    id: "path2771"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 663.9,503.9 h 23 v 60.6 c 0,11.9 -4.7,23.2 -13.1,31.7 -4.6,4.6 -10,8.1 -15.9,10.2 1.6,0.9 2.3,1.9 2.3,2.8 0,6.4 -34,11.6 -76,11.6 -42,0 -76,-5.2 -76,-11.6 0,-1 0.8,-1.9 2.3,-2.8 -5.9,-2.2 -11.3,-5.7 -15.9,-10.2 -8.4,-8.4 -13.1,-19.8 -13.1,-31.7 v -60.6 h 25.1 V 548 h 157.3 z m 1.6,1.6 h 19.9 v 59 c 0,11.4 -4.6,22.4 -12.7,30.6 -4.3,4.4 -9.6,7.7 -15.3,9.9 -0.6,0.2 -1,0.7 -1.1,1.4 0,0.6 0.2,1.2 0.7,1.6 0.5,0.3 0.8,0.5 1.2,0.9 0.2,0.2 0.4,0.4 0.4,0.6 0,0.2 -0.1,0.4 -0.4,0.5 -0.2,0.3 -0.6,0.5 -1.1,0.8 -1.3,0.8 -3.4,1.6 -5.9,2.4 -12.5,3.8 -37.9,6.2 -67.1,6.2 -29.2,0 -54.4,-2.6 -67.1,-6.2 -2.5,-0.7 -4.6,-1.6 -5.9,-2.4 -0.5,-0.3 -0.8,-0.5 -1.1,-0.8 -0.2,-0.2 -0.4,-0.4 -0.4,-0.5 0,-0.2 0.1,-0.4 0.4,-0.6 0.2,-0.3 0.7,-0.5 1.2,-0.9 0.5,-0.3 0.8,-0.9 0.7,-1.6 0,-0.6 -0.5,-1.1 -1.1,-1.4 -5.7,-2.1 -11,-5.5 -15.3,-9.9 -8.1,-8.1 -12.7,-19 -12.7,-30.6 v -59 h 21.6 V 548 c 0,0.9 0.7,1.6 1.6,1.6 h 157.3 c 0.8,0 1.6,-0.7 1.6,-1.6 v -42.5 z",
    id: "path2773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 484.3,509.2 1.2,60.1 c 0,0.2 0,0.2 0,0.4 1.2,9.3 5.1,17.4 9.7,23.3 2.3,3 4.7,5.4 7.2,7.2 1.2,0.9 2.5,1.6 3.8,2.2 1.3,0.5 2.7,0.9 4.1,0.9 0.7,0 1.5,-0.1 2.3,-0.3 0.8,-0.2 1.5,-0.6 2.2,-1.1 1.7,-1.3 2,-3.7 0.7,-5.4 -1.3,-1.7 -3.7,-2 -5.4,-0.7 l 0.4,0.6 -0.2,-0.7 -0.2,0.1 0.4,0.6 -0.2,-0.7 0.1,0.3 v -0.3 0 l 0.1,0.3 v -0.3 h -0.1 c -0.1,0 -0.6,-0.1 -1.2,-0.3 -1.1,-0.4 -2.7,-1.5 -4.3,-3 -2.5,-2.3 -5.1,-5.7 -7.3,-9.7 -2.2,-4.1 -3.8,-8.8 -4.5,-13.8 l -3.8,0.5 3.8,-0.1 -1.2,-60.1 c 0,-2.1 -1.8,-3.8 -3.9,-3.7 -2,-0.1 -3.7,1.6 -3.7,3.7 z",
    id: "path2775"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    cx: 584.40002,
    cy: 536.59998,
    rx: 78,
    ry: 11.1,
    id: "ellipse2777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 584.4,525.6 c 43.1,0 78,5 78,11.1 0,6.1 -34.9,11.1 -78,11.1 -43.1,0 -78,-5 -78,-11.1 -0.1,-6.1 34.9,-11.1 78,-11.1 z m 0,0.9 c 30,0 56.2,2.4 69,6 3.3,0.9 5.5,1.8 6.9,2.8 0.6,0.5 1,0.9 1,1.5 0,0.5 -0.4,1 -1,1.5 -1.4,1 -3.7,1.9 -6.9,2.8 -12.9,3.5 -39,6 -69,6 -30,0 -56.2,-2.4 -69,-6 -3.3,-0.9 -5.5,-1.8 -6.9,-2.8 -0.6,-0.5 -1,-0.9 -1,-1.5 0,-0.5 0.4,-1 1,-1.5 1.4,-1 3.7,-1.9 6.9,-2.8 12.8,-3.6 38.9,-6 69,-6 z",
    id: "path2779"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.79999,
    y: 504.20001,
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 20.299999,
    height: 5.3000002,
    id: "rect2781"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 611.9,530.6 c 34.3,-0.3 95.8,13.9 -40.6,13.9 -110.3,-2.1 130.6,0.1 40.6,-13.9 z",
    id: "path2783"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 606.4,532.1 c 0,0 -119.8,-1.7 -59.7,7.8 -52,1.8 -25.7,-16.1 59.7,-7.8 z",
    id: "path2785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 683,560 v 0 c 0,0.2 0.1,1 0.1,2.4 0,4 -0.5,12.2 -3.9,19.6 -1.7,3.7 -4.2,7.2 -7.6,9.9 -3.5,2.7 -8,4.6 -13.9,5.2 h -0.1 c -0.5,0.1 -0.9,0.1 -1.3,0.1 -0.6,0 -1.1,0.5 -1.1,1.1 0,0.6 0.5,1.1 1.1,1.1 0.6,0 1.1,-0.1 1.6,-0.1 l -0.2,-1.1 0.1,1.1 c 6.3,-0.6 11.3,-2.7 15.1,-5.6 5.7,-4.4 8.8,-10.8 10.5,-16.7 1.7,-5.9 2,-11.5 2,-14.6 0,-1.6 -0.1,-2.5 -0.1,-2.5 0,-0.6 -0.6,-1.1 -1.2,-1 -0.7,-0.1 -1.1,0.4 -1.1,1.1 z",
    id: "path2787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 514.2,608 c 0,0 36.6,6.5 76.9,6.5 21.7,0 44.4,-1.9 63.3,-7.6 l -0.6,-1.9 c -18.6,5.7 -41.2,7.6 -62.7,7.5 -20.1,0 -39.2,-1.6 -53.4,-3.2 -7.1,-0.8 -12.9,-1.6 -16.9,-2.2 -2,-0.3 -3.6,-0.6 -4.7,-0.7 -1.1,-0.2 -1.6,-0.3 -1.6,-0.3 z",
    id: "path2789"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 575.70001,
    cy: 537.09998,
    rx: 22.9,
    ry: 2,
    id: "ellipse2791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffcfc",
    d: "m 497.3,510.7 0.6,58.5 v 0.1 c 0,0 0.5,4.2 2.6,9.2 2.1,5.1 5.7,11.1 11.9,14.7 0.4,0.2 1,0.1 1.2,-0.3 0.2,-0.4 0.1,-1 -0.3,-1.2 -5.8,-3.4 -9.2,-9 -11.2,-13.9 -1,-2.4 -1.6,-4.6 -2,-6.2 -0.2,-0.8 -0.3,-1.4 -0.4,-1.9 0,-0.2 -0.1,-0.4 -0.1,-0.5 v -0.1 0 l -0.9,0.1 h 0.9 L 499,510.7 c 0,-0.5 -0.4,-0.9 -0.9,-0.9 -0.4,0 -0.8,0.4 -0.8,0.9 z",
    id: "path2793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffcfc",
    d: "m 685.3,559.9 v -52.3 c 0,-0.6 -0.5,-1.1 -1.1,-1.1 -0.6,0 -1.1,0.5 -1.1,1.1 v 52.3 c 0,0.6 0.5,1.1 1.1,1.1 0.6,0 1.1,-0.5 1.1,-1.1",
    id: "path2795"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.20001,
    y: 432.60001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-119.1301,686.6057)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 146.3,
    height: 45.200001,
    id: "rect2797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 525.8,503.3 563.3,528.5 645,407.2 607.5,382 Z m 4.9,-1 77.7,-115.5 31.6,21.3 c 0,0 -65.5,97.3 -77.7,115.5 z",
    id: "path2799"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 651,413.4 c 0,0 -8.5,-2.7 -15.5,7.7 -10.4,-4.3 -5.7,-8.6 -5.7,-8.6 l 12.3,-7.3 z",
    id: "path2801"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 599.4,378.7 c 0,0 5.7,6.8 -1.3,17.2 7.9,8 10.1,2 10.1,2 l 2.1,-14.1 z",
    id: "path2803"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-187.5118,679.5434)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 544.5,
    cy: 515.90002,
    rx: 9.5,
    ry: 22.6,
    id: "ellipse2805"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 539.2,523.8 c -10.3,-7 -16.4,-16.1 -13.4,-20.5 2.9,-4.3 13.7,-2.2 24,4.7 10.3,7 16.4,16.1 13.4,20.5 -2.9,4.4 -13.6,2.2 -24,-4.7 z m 2,-2.9 c -5.6,-3.8 -9.9,-8.2 -11.8,-12 -0.4,-0.8 -0.7,-1.6 -0.8,-2.3 -0.1,-0.5 -0.2,-0.9 0.1,-1.3 0.2,-0.3 0.7,-0.4 1.2,-0.6 0.7,-0.2 1.5,-0.2 2.4,-0.1 4.3,0.3 10,2.6 15.6,6.4 5.6,3.8 9.9,8.2 11.8,12 0.4,0.8 0.7,1.6 0.8,2.3 0.1,0.5 0.2,0.9 -0.1,1.3 -0.2,0.3 -0.7,0.4 -1.2,0.6 -0.7,0.2 -1.5,0.2 -2.4,0.1 -4.3,-0.4 -10,-2.7 -15.6,-6.4 z",
    id: "path2807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 529.2,522.5 c -1.1,1.6 -1.4,3.5 -1.1,5.3 0.4,1.8 1.4,3.5 3,4.5 1,0.7 2.1,1.4 3.2,2.1 1.6,1.1 3.5,1.4 5.3,1.1 1.8,-0.4 3.5,-1.4 4.5,-3 2,-3 4,-6 4,-6 l -15,-10.1 z",
    id: "path2809"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 529.2,522.5 c -1.1,1.6 -1.4,3.5 -1.1,5.3 0.4,1.8 1.4,3.5 3,4.5 1,0.7 2.1,1.4 3.2,2.1 1.6,1.1 3.5,1.4 5.3,1.1 1.8,-0.4 3.5,-1.4 4.5,-3 2,-3 4,-6 4,-6 l -15,-10.1 z m 2.9,2 2.1,-3.1 9.1,6.1 -2.1,3.1 c -0.5,0.8 -1.3,1.3 -2.3,1.5 -0.9,0.2 -1.9,0 -2.7,-0.5 -1,-0.7 -2.1,-1.4 -3.2,-2.1 -0.8,-0.5 -1.3,-1.3 -1.5,-2.3 -0.1,-1 0.1,-1.9 0.6,-2.7 z",
    id: "path2811"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.59998,
    y: 530.5,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-208.3582,677.3698)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 4.9000001,
    height: 7.8000002,
    id: "rect2813"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.59998,
    y: 530.5,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-208.3582,677.3698)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 4.9000001,
    height: 7.8000002,
    id: "rect2815"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.59998,
    y: 337.79999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,2.9752,696.964)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 23,
    height: 15.8,
    id: "rect2817"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 622,382.1 14.8,10 32.3,-51.5 -13.1,-8.8 z m 26,-32.3 8.9,-13.2 7.3,4.9 -8.9,13.2 z",
    id: "path2819"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.20001,
    y: 311.60001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,16.463,698.3423)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 5.9000001,
    height: 44.200001,
    id: "rect2821"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.20001,
    y: 311.60001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,16.463,698.3423)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 5.9000001,
    height: 44.200001,
    id: "rect2823"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 664.2,333.7 c -10.1,-6.8 -17.8,-13.1 -17.1,-14.1 0.7,-1 9.4,3.7 19.5,10.5 10.1,6.8 17.8,13.1 17.1,14.1 -0.7,1 -9.4,-3.7 -19.5,-10.5 z",
    id: "path2825"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.79999,
    y: 350.39999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-48.0309,694.0166)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 10,
    height: 83.400002,
    id: "rect2827"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 590.4,372.9 69.2,46.6 5.6,-8.3 -69.2,-46.6 z m 4.9,-0.9 1.7,-2.5 63.4,42.7 -1.7,2.5 z",
    id: "path2829"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    points: "612.7,383.3 641,402.7 558.5,525.3 530.1,506.2 ",
    id: "polygon2831"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    points: "562.4,460.4 588.7,478.1 557.6,524.3 531.3,506.6 ",
    id: "polygon2833"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 467.79999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-145.758,675.8836)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    width: 3.9000001,
    height: 14,
    id: "rect2835"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.09998,
    y: 448.5,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-123.9317,678.1933)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 3.9000001,
    height: 14,
    id: "rect2837"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.59998,
    y: 428.29999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-101.1851,680.5034)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 3.9000001,
    height: 14,
    id: "rect2839"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.59998,
    y: 428.29999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-101.1851,680.5034)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 3.9000001,
    height: 14,
    id: "rect2841"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.40002,
    y: 464,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-140.2599,674.494)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    width: 2,
    height: 9.8999996,
    id: "rect2843"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.5,
    y: 444.60001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-118.341,676.8116)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2845"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.09998,
    y: 424.39999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-95.5963,679.1265)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2847"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.09998,
    y: 424.39999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-95.5963,679.1265)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2849"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.70001,
    y: 460.70001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-136.4451,674.9387)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    width: 2,
    height: 9.8999996,
    id: "rect2851"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.79999,
    y: 441.20001,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-114.5169,677.1657)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2853"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.40002,
    y: 421,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-91.7791,679.5711)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2855"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.40002,
    y: 421,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-91.7791,679.5711)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2857"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.90002,
    y: 457.39999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-132.748,675.3281)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2859"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 437.89999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-110.8176,677.5504)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.59998,
    y: 417.79999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-88.081,679.9571)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2863"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.59998,
    y: 417.79999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-88.081,679.9571)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.20001,
    y: 453.89999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-128.8715,675.6882)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2867"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.40002,
    y: 434.5,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-106.9517,678.0077)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2869"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.90002,
    y: 414.29999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-84.207,680.3226)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2871"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.90002,
    y: 414.29999,
    transform: "matrix(0.5584,-0.8296,0.8296,0.5584,-84.207,680.3226)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 2,
    height: 9.8999996,
    id: "rect2873"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    d: "m 591.9,372.8 4.5,-6.5 16.1,11.3 c -0.1,0 -13.4,-6.6 -20.6,-4.8 z",
    id: "path2875"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    d: "m 665,329.8 c 0,0 -12.9,-3.8 -8.7,1.5 -3.3,-3.2 -10.9,-7.5 -10.9,-7.5 l 2.4,-4.1 z",
    id: "path2877"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 657,332.6 9,6.9 c 0,0 -36.3,41.8 -39.1,46.3 -2.3,-1.7 -3.9,-2.9 -3.9,-2.9 z",
    id: "path2879"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 602,379.9 c 0,0 2.6,11.3 -1.8,15.6 -4.4,4.2 12.5,-12.1 12.5,-12.1 0,0 -6.9,-2.2 -10.7,-3.5 z",
    id: "path2881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 604.5,387.5 527.2,503 c -0.2,0.4 -0.1,0.9 0.2,1.1 0.4,0.2 0.9,0.1 1.1,-0.2 l 77.3,-115.5 c 0.2,-0.4 0.1,-0.9 -0.2,-1.1 -0.3,-0.2 -0.8,-0.1 -1.1,0.2",
    id: "path2883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 644.5,399.4 17.4,12.2 -3.5,5.5 c -0.2,0.4 -0.1,0.9 0.3,1.1 0.4,0.2 0.9,0.1 1.1,-0.3 l 3.9,-6.1 c 0.2,-0.4 0.1,-0.8 -0.2,-1.1 l -18,-12.7 c -0.4,-0.3 -0.9,-0.2 -1.1,0.2 -0.4,0.5 -0.3,1 0.1,1.2 z",
    id: "path2885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 527.3,503 c -0.1,0.1 -0.9,1.1 -0.9,3.1 0,1.2 0.3,2.8 1.3,4.8 1,1.9 2.7,4.2 5.4,6.9 0.3,0.3 0.8,0.3 1.1,0 0.3,-0.3 0.3,-0.8 0,-1.1 -2.6,-2.6 -4.2,-4.7 -5.1,-6.5 -0.9,-1.8 -1.2,-3.1 -1.2,-4 0,-0.7 0.2,-1.3 0.3,-1.6 0.1,-0.2 0.1,-0.3 0.2,-0.4 v -0.1 0 l -0.3,-0.3 0.3,0.3 v 0 l -0.3,-0.3 0.3,0.3 c 0.3,-0.3 0.3,-0.8 -0.1,-1.1 -0.2,-0.4 -0.7,-0.3 -1,0 z",
    id: "path2887"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fffcfc",
    d: "m 533.7,517.2 -4,7.8 c 0,0 -0.8,4 0.4,4.9 1.1,0.9 2.1,0.7 2.1,0.7 l 6.8,-11.2 z",
    id: "path2889"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g2968",
    transform: "translate(-481.5,-161.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2896"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 313.8,-748 3.9,2.2",
    id: "path2894"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2910"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs2899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M 676.3,352.2 660,356.7 516,551.2 c 0,0 -21.8,13.1 -3.2,-11.2 18.2,-23.6 123.6,-185.9 130,-192.8 -0.6,-4.4 -12.8,-47.6 -14,-66.5 29.1,-21.5 31.2,-28.2 31.2,-28.2 l -75.5,26.3 c 0,0 -25.2,3.4 -25.7,-7.4 58.2,-30.3 87.6,-44.8 87.6,-44.8 L 593,224.2 c 0,0 -17.2,-1.7 -20.7,-15.1 72,-5.7 117.9,-2.2 117.9,-2.2 0,0 -46.9,-24.1 -49,-45.3 63.2,30.5 82.6,46.2 82.6,46.2 0,0 171.3,31.9 164.4,77 0,0 5.6,50 -36.8,73.5 -9,-14.1 -27,-35.4 -39.2,-46.4 -17.4,5.1 -36.3,19 -68.6,19.9 -25.6,5.7 -39,13 -73,21.9 -1,-0.1 6.5,-1.2 5.7,-1.5 z m 29.5,-63 c 0,0 -0.8,-6.9 -0.6,-6.2 1,4.8 4.9,39.7 -27.2,46.9 17.4,-18.9 27.8,-40.7 27.8,-40.7 z m -12,-15.8 -14.4,2.6 -19.2,23.9 -3.5,24.8 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158711737172836846780000008391025864318248631_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    id: "use2901"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000158711737172836846780000008391025864318248631_)",
    id: "g2908"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3472.85,-1022.39)",
    id: "g2906"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 1.3079,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m -2584.7,1307.3 c 0,0 5.6,50 -36.8,73.5 -9,-14.1 -27.1,-35.4 -39.2,-46.4 -17.5,5.1 -36.3,19 -68.6,19.9 -25.6,5.7 -56.2,16.3 -90.2,25.1 -4,-1 -2,-6.3 -3.9,-7.5 -8.1,-5 -16.2,-11.2 -16.2,-11.2 0,0 -4.1,-41.4 -5.3,-61.2 30.5,-21.3 32.2,-24.5 32.2,-24.5 l -75.5,26.3 c 0,0 -25.2,3.4 -25.7,-7.4 58.2,-30.3 87.6,-44.8 87.6,-44.8 l -53.4,-2.4 c 0,0 -17.2,-1.7 -20.7,-15.1 72,-5.7 117.9,-2.2 117.9,-2.2 0,0 -46.9,-24.1 -49,-45.3 63.2,30.6 82.6,46.2 82.6,46.2 0,0 171.1,31.9 164.2,77 z m -186.8,-12.3 c 0,0 5.8,19.6 5.9,20.4 1,4.8 2.5,26.6 -29.6,33.9 -34.8,20.5 -19.6,-7.7 -16.8,-13 4.4,-8.3 16.9,-30.9 24.5,-37.2 7.2,-6 16,-4.1 16,-4.1 z",
    id: "path2904"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.963475,0,0,0.950619,408.536,1115.69)",
    id: "g2914"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 277.4,-804.9 c 0,0 2.9,-13.7 -3.2,-12.6 -6.1,1.1 -15.6,13.2 -13.2,14.9 2.3,1.6 16.4,-2.3 16.4,-2.3 z",
    id: "path2912"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.08388,0,0,1.16469,309.786,919.156)",
    id: "g2918"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 304.2,-513.3 c 0,0 5.2,5.2 5.4,7.7 0.2,2.5 1.7,11.9 -0.5,11.5 -2.1,-0.3 -6.3,-12.3 -4.9,-19.2 z",
    id: "path2916"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2922"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 282,-771.2 c 0,0 -7.2,-6.4 -5.3,-12",
    id: "path2920"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2926"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 281.1,-767.5 c 0,0 -7.7,0 -9.4,-3.5",
    id: "path2924"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2930"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 310.8,-747.2 c 0,0 4.4,4.8 2.9,6.7",
    id: "path2928"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 232.3,-800.5 c 0,0 -2.5,-6.5 -0.5,-8.9",
    id: "path2932"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2938"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 227.8,-799.4 c 0,0 -2.1,-5.9 -4.8,-5.8",
    id: "path2936"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2942"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "m 196.4,-806 c 0,0 -11.3,8.7 -14.3,7.4 -3,-1.4 14.3,-7.4 14.3,-7.4 z",
    id: "path2940"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2946"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 336.1,-778.2 c 0,0 -8.7,-1.4 -10.8,1.3",
    id: "path2944"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2950"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 231,-848.8 -3.6,3.9",
    id: "path2948"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2954"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 225.8,-852.7 -2.7,7.9",
    id: "path2952"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2958"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 294.7,-878.8 -4.8,3.4",
    id: "path2956"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2962"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 291.2,-882.7 -4.2,5",
    id: "path2960"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g2966"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.765,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 455.1,-759.2 -11.4,-2.4 c 0,0 -9.1,4.1 -12.6,3.7",
    id: "path2964"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadSyringeWithHand);
export default __webpack_public_path__ + "static/media/load-syringe-with-hand.ab292e95bb28928175670b8ba2f004c2.svg";
export { ForwardRef as ReactComponent };